//If not using the auto-generated hooks
// import { FetchArgs, createApi, fetchBaseQuery } from "@reduxjs/toolkit/query";
//If using the auto-generated hooks
import {
  FetchArgs,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { VITE_API_URL } from "../../config";
import { AppState, authActions, mutex_logout } from "../states";
import qs from "query-string";
import { BaseQueryApi } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { Mutex } from "async-mutex";
import { INTERNAL, validateRoles } from "../../lib";
/**
 * Command to generate all the endpoints
 * npx @rtk-query/codegen-openapi openapi-config.json
 */
let token: string | undefined = undefined;
const baseQuery = fetchBaseQuery({
  baseUrl: VITE_API_URL,
  prepareHeaders: (headers, { getState }) => {
    token = (getState() as any)?.auth?.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
  paramsSerializer: (params) =>
    qs.stringify(params, { skipNull: true, arrayFormat: "bracket" }),
});

const mutex = new Mutex();

const baseQueryWithReAuth = async (
  args: FetchArgs,
  api: BaseQueryApi,
  extraOptions: {},
) => {
  // wait until the mutex is available without locking it
  await mutex.waitForUnlock();
  const state = api.getState() as AppState;
  const isImpersonating = !!state.auth.oldAuth;
  if (isImpersonating) {
    const isInternal = validateRoles(
      state.auth.roles?.map((role) => role.internal_name) || [],
      INTERNAL,
    );
    if (
      !isInternal &&
      (args.url.includes("-1") ||
        args.url === "/users" ||
        args.url === "/account_managers" ||
        args.url === "/timer/actions")
    ) {
      console.warn("Aborting call in impersonation mode with -1");
      api.abort();
    }
  }
  let result = await baseQuery(args, api, extraOptions);
  //TODO: deal with 403
  // try to get a token
  // if (params.get("uuid")) {
  //   authResult = await baseQuery(
  //     {
  //       url: "/auth/uuid-login",
  //       method: "POST",
  //       body: { uuid: params.get("uuid") },
  //     },
  //     api,
  //     extraOptions,
  //   );
  // }
  //https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#preventing-multiple-unauthorized-errors
  if (result.error && result.error.status === 401) {
    // checking whether the mutex is locked
    if (!mutex.isLocked()) {
      const release = await mutex.acquire();
      try {
        const refreshResult = await baseQuery(
          "/auth/refresh-token",
          api,
          extraOptions,
        );
        if (refreshResult.data) {
          api.dispatch(authActions.load(refreshResult.data));
          // retry the initial query
          result = await baseQuery(args, api, extraOptions);
        } else {
          console.warn("Failed to refresh - logging out");
          token = undefined;
          await mutex_logout();
        }
      } finally {
        // release must be called once the mutex should be released again.
        release();
      }
    } else {
      // wait until the mutex is available without locking it
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extraOptions);
    }
  }
  return result;
};
export const api = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReAuth,
  endpoints: () => ({}),
});
